import React from 'react';
import { Link } from 'react-router-dom';
import IdentityCard from '../components/IdentityCard';

const Portfolio: React.FC = () => {
  return (
    <div className="App">
      <IdentityCard />
      {/* Header Section */}
      <section className="section-compact">
        <div className="container">
          <div className="text-center animate-fade-in-up">
            <h1 className="page-title">My Research Portfolio</h1>
          </div>
        </div>
      </section>

      {/* Portfolio Viewer Section */}
      <section className="section">
        <div className="container">
          <div className="card animate-fade-in-up">
            <div className="card-header">
              <h2 className="card-title">Portfolio Presentation</h2>
              <p className="card-description">
                Explore my complete research portfolio including methodologies, findings, 
                and impact across multiple projects in accessibility and UX research.
              </p>
            </div>
            
            <div className="portfolio-viewer">
              <div className="portfolio-presentation">
                <iframe
                  src="https://docs.google.com/presentation/d/1cV9T2qa1iRUs2O4NhCh3p0Y3neHfI-YcUkwMFDqvC8Y/embed?start=false&loop=false&delayms=3000"
                  width="100%"
                  height="600"
                  title="Research Portfolio Presentation"
                  className="portfolio-iframe"
                  frameBorder="0"
                  allowFullScreen
                >
                  <div className="portfolio-fallback">
                    <div className="portfolio-icon">
                      <svg width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                        <path d="M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4"/>
                        <polyline points="7,10 12,15 17,10"/>
                        <line x1="12" y1="15" x2="12" y2="3"/>
                      </svg>
                    </div>
                    <h3>Research Portfolio Presentation</h3>
                    <p>
                      This comprehensive PowerPoint presentation showcases my research methodology, 
                      findings, and impact across multiple projects in accessibility and UX research.
                    </p>
                    <div className="portfolio-features">
                      <div className="feature-item">
                        <strong>40+ slides</strong> of detailed research documentation
                      </div>
                      <div className="feature-item">
                        <strong>Visual case studies</strong> with methodology breakdowns
                      </div>
                      <div className="feature-item">
                        <strong>Impact metrics</strong> and validation results
                      </div>
                      <div className="feature-item">
                        <strong>Technical implementations</strong> and code examples
                      </div>
                    </div>
                    <p className="portfolio-fallback-text">
                      Unable to load presentation. Please view directly on Google Slides.
                    </p>
                  </div>
                </iframe>
              </div>
            </div>

            <div className="portfolio-actions">
              <a 
                href="https://docs.google.com/presentation/d/1cV9T2qa1iRUs2O4NhCh3p0Y3neHfI-YcUkwMFDqvC8Y/edit?slide=id.p3#slide=id.p3"
                target="_blank"
                rel="noopener noreferrer"
                className="btn btn-dark portfolio-download-btn"
              >
                View Full Presentation
              </a>
              <Link to="/" className="btn btn-secondary">
                Back to Home
              </Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Portfolio;
